import {createAction} from 'redux-actions'

export default function({
    actionTypes: {
        PANEL_OPEN,
        PANEL_CLOSE,

        USER_ID_SET,
        PANEL_TAB_SET,

        TASK_IDS_SET,
        PROJECT_IDS_SET,
        CUSTOMER_IDS_SET,

        MANAGE_CUSTOMER_IDS_SET,
        MANAGE_EXCLUDING_SELF_CUSTOMER_IDS_SET,
        MANAGE_PROJECT_IDS_SET,
        MANAGE_EXCLUDING_SELF_PROJECT_IDS_SET,
        MANAGE_TASK_IDS_SET,

        TASK_TAB_LOADED,
        PROJECT_TAB_LOADED,
        CUSTOMER_TAB_LOADED,

        USER_COUNTERS_SET,
        VIEWER_COUNTERS_SET,

        PANEL_SEARCH_STRING_SET,
        PANEL_SEARCH_OPEN_SET,

        LOADED_SET,
        LOADING_SET,
        SET_IS_SHOW_ARCHIVE_ENTITIES,
    }
}) {
    const setTaskIds = createAction(TASK_IDS_SET)
    const setProjectIds = createAction(PROJECT_IDS_SET)
    const setCustomerIds = createAction(CUSTOMER_IDS_SET)

    const setUserId = createAction(USER_ID_SET)
    const setTab = createAction(PANEL_TAB_SET)

    const setManageTaskIds = createAction(MANAGE_TASK_IDS_SET)
    const setManageProjectIds = createAction(MANAGE_PROJECT_IDS_SET)
    const setManageExcludingSelfProjectIds = createAction(MANAGE_EXCLUDING_SELF_PROJECT_IDS_SET)
    const setManageCustomerIds = createAction(MANAGE_CUSTOMER_IDS_SET)
    const setManageExcludingSelfCustomerIds = createAction(MANAGE_EXCLUDING_SELF_CUSTOMER_IDS_SET)

    const setUserCounters = createAction(USER_COUNTERS_SET)

    const setCustomerTabLoaded = createAction(CUSTOMER_TAB_LOADED)
    const setProjectTabLoaded = createAction(PROJECT_TAB_LOADED)
    const setTaskTabLoaded = createAction(TASK_TAB_LOADED)
    const setSearchString = createAction(PANEL_SEARCH_STRING_SET)
    const setSearchOpen = createAction(PANEL_SEARCH_OPEN_SET)

    const setLoaded = createAction(LOADED_SET)
    const setLoading = createAction(LOADING_SET)

    const openPanel = createAction(PANEL_OPEN)
    const closePanel = createAction(PANEL_CLOSE)

    const setIsShowArchiveEntities = createAction(SET_IS_SHOW_ARCHIVE_ENTITIES)

    const clearTabsLoaded = () => dispatch => {
        dispatch(setLoaded(false))
        dispatch(setCustomerTabLoaded(false))
        dispatch(setProjectTabLoaded(false))
        dispatch(setTaskTabLoaded(false))
    }

    const resetSearch = () => dispatch => {
        dispatch(setSearchOpen(false))
        dispatch(setSearchString(null))
    }

    return {
        setTaskIds,
        setProjectIds,
        setCustomerIds,
        setUserId,
        setTab,
        setManageTaskIds,
        setManageProjectIds,
        setManageExcludingSelfProjectIds,
        setManageCustomerIds,
        setManageExcludingSelfCustomerIds,
        setUserCounters,
        setCustomerTabLoaded,
        setProjectTabLoaded,
        setTaskTabLoaded,
        setSearchString,
        setSearchOpen,
        setLoaded,
        setLoading,
        openPanel,
        closePanel,
        clearTabsLoaded,
        setIsShowArchiveEntities,
        resetSearch
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/hierarchyAssignmentsPanelTab/actionsGenerator.js